module.exports = __webpack_public_path__ + "img/agreed-value-coverage.4a57f679.jpg";